import React, { FC } from 'react'

import { MainContainer } from '@components/MainContainer/styles'
import useStoreMain from '@store/mainStore'

interface IProperties {
    hasDeployed: boolean
    isLoading: boolean
}

export const LoadingPage: FC<IProperties> = properties => {
    const { errorMessage } = useStoreMain()

    if (errorMessage) {
        return (
            <MainContainer isCentered>
                <h1>{errorMessage}</h1>
            </MainContainer>
        )
    }

    if (properties.isLoading)
        return (
            <MainContainer isCentered>
                <h1>Loading...</h1>
            </MainContainer>
        )

    if (!properties.hasDeployed)
        return (
            <MainContainer isCentered>
                <h1>The collection has not been deployed</h1>
            </MainContainer>
        )

    return null
}
